import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const InvoicesNewPage = lazy(() => import("@/pages/invoices.new.page"));

export const Route = createFileRoute("/invoices/new")({
  component: InvoicesNewPage,
  validateSearch: (
    search: Record<string, unknown>,
  ): { partyId?: string; biltyId?: string } => ({
    partyId: typeof search.partyId === "string" ? search.partyId : undefined,
    biltyId: typeof search.biltyId === "string" ? search.biltyId : undefined,
  }),
});
